import React from 'react';

const FullscreenDouble = ({ height = 32, width = 32, color = '#494949' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>fullscreen</title>
    <g>
      <path d="M15.87883,29.29305L6,39.17188V30H2v14c0,1.10457,0.89543,2,2,2h14v-4H8.82812l9.87883-9.87883 c0.39053-0.39053,0.39053-1.02369,0-1.41422l-1.41391-1.41391C16.90252,28.90252,16.26936,28.90252,15.87883,29.29305z" fill={color} />
      <path d="M44,2H30v4h9.17188l-9.87883,9.87883c-0.39053,0.39052-0.39053,1.02369,0,1.41421l1.41391,1.41391 c0.39053,0.39053,1.02369,0.39053,1.41422,0L42,8.82812V18h4V4C46,2.89543,45.10457,2,44,2z" fill={color} />
    </g>
  </svg>
);

export default FullscreenDouble;
